import { useQuery } from '@tanstack/react-query';
import QUERY_KEYS from '../utils/QueryKeys';
import { Cart } from '../models';

export default function useCart(id) {
  return useQuery([QUERY_KEYS.CART, id], () => (
    Cart
      .where({ id })
      .first()
      .then((res) => res.data)
  ), { enabled: !!id });
}
